import styled from "styled-components";

export const DemoLimitsHintStyled = styled.div`
    position: relative;
    
    .hint-wrapper {
        position: absolute;
        width: 342px;
        right: -16px;
        top: calc(100% + 8px);
        z-index: 3;
        
        &.mobile {
            width: 100%;
            left: 0;
            top: -136px;
        }
    }
`;
